import { TrendingMovie } from "../interfaces/interfaces";
import { MovieDetails, MovieVideo } from "../interfaces/interfaces";

const apiKey = process.env.REACT_APP_MOVIE_API_KEY;
export const TMDB_CONFIG = {
    BASE_URL: 'https://api.themoviedb.org/3',
    API_KEY: apiKey,
    headers: {
        accept: 'application/json',
        Authorization: `Bearer ${apiKey}`,
    }
}


export const fetchMovies = async({ query }: { query: string}) => {
    const endpoint = query
        ?  `${TMDB_CONFIG.BASE_URL}/search/movie?query=${encodeURIComponent(query)}`
        : `${TMDB_CONFIG.BASE_URL}/discover/movie?sort_by=popularity.desc`;
    
    console.log("Fetching from:", endpoint);

    const response = await fetch(endpoint, {
        method: 'GET',
        headers: TMDB_CONFIG.headers,
    });

    if(!response.ok) {
        // @ts-ignore
        throw new Error('Failed to fetch movies', response.statusText);
    }

    const data = await response.json();

    return data.results;
}

export const fetchMovieDetails = async (
  movieId: string
): Promise<MovieDetails> => {
  try {
    const response = await fetch(
      `${TMDB_CONFIG.BASE_URL}/movie/${movieId}?api_key=${TMDB_CONFIG.API_KEY}`,
      {
        method: "GET",
        headers: TMDB_CONFIG.headers,
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch movie details: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching movie details:", error);
    throw error;
  }
};


/**
 * Fetch the Video of the Movie
 */
export const fetchMovieVideos = async (movieId: string): Promise<MovieVideo[]> => {
  try {
    const response = await fetch(
      `https://api.themoviedb.org/3/movie/${movieId}/videos?api_key=${TMDB_CONFIG.API_KEY}`,
      {
        method: "GET",
        headers: TMDB_CONFIG.headers,
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch movie videos: ${response.statusText}`);
    }

    const data = await response.json();
    return data.results as MovieVideo[];
  } catch (error) {
    console.error("Error fetching movie videos:", error);
    return [];
  }
};